import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=0ae7a8bf"
import script from "./Page2.vue?vue&type=script&lang=ts"
export * from "./Page2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports